import { ClientErrorCode } from '../errors';
import { RageVehicleType } from './vehicles';

export enum CharacterLicense {
	DrivingBike = 'driving_bike',
	DrivingCar = 'driving_car',
	DrivingTruck = 'driving_truck',
	DrivingBus = 'driving_bus',
	Sailing = 'sailing',
	Flying = 'flying',
}

export const vehicleTypeToLicenseType = new Map<RageVehicleType, CharacterLicense>([
	[RageVehicleType.CAR, CharacterLicense.DrivingCar],
	[RageVehicleType.TRUCK, CharacterLicense.DrivingTruck],
	[RageVehicleType.BUS, CharacterLicense.DrivingBus],
	[RageVehicleType.BIKE, CharacterLicense.DrivingBike],
	[RageVehicleType.BOAT, CharacterLicense.Sailing],
	[RageVehicleType.EMERGENCY_BOAT, CharacterLicense.Sailing],
	[RageVehicleType.HELICOPTER, CharacterLicense.Flying],
	[RageVehicleType.PLANE, CharacterLicense.Flying],
	// [RageVehicleType.Quadbike, CharacterLicense.DrivingBike],
]);

export const licenseTypeToClientErrorCode = (licenseType: CharacterLicense): ClientErrorCode => {
	switch (licenseType) {
		case CharacterLicense.DrivingBike:
			return ClientErrorCode.DrivingBikeLicenseNotOwned;
		case CharacterLicense.DrivingCar:
			return ClientErrorCode.DrivingCarLicenseNotOwned;
		case CharacterLicense.DrivingTruck:
			return ClientErrorCode.DrivingTruckLicenseNotOwned;
		case CharacterLicense.DrivingBus:
			return ClientErrorCode.DrivingBusLicenseNotOwned;
		case CharacterLicense.Sailing:
			return ClientErrorCode.SailingLicenseNotOwned;
		case CharacterLicense.Flying:
			return ClientErrorCode.FlyingLicenseNotOwned;
		default:
			return ClientErrorCode.LicenseNotOwned;
	}
};
